import { Input, OnInit, Component } from '@angular/core';

@Component({
	selector: 'pluralize',
	template: `<span>{{content}}</span>`,
	standalone: false,
})
export class PluralizeComponent implements OnInit {
	@Input() count;
	@Input() when;
	@Input() offset;

	private _content: string;

	ngOnInit() {
		const when = this.when;
		const count = this.count;
		const oneOffset = this.offset ? this.offset + 1 : 1;
		const remainingOffset = this.offset ? count - this.offset : count;
		let content = when[0] || '';

		if (this.when) {
			if (when[count]) {
				content = when[count];
			} else {
				if (count === oneOffset && when.one) {
					content = when.one;
				} else {
					content = when.other || '';
				}
			}
			content = content.replace('{}', remainingOffset);
		}
		this._content = content;
	}

	get content(): string {
		return this._content;
	}
}
